import { render } from "./salesReportTable.vue?vue&type=template&id=b064a048&scoped=true"
import script from "./salesReportTable.vue?vue&type=script&lang=js"
export * from "./salesReportTable.vue?vue&type=script&lang=js"

import "./salesReportTable.vue?vue&type=style&index=0&id=b064a048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b064a048"]])

export default __exports__